const state = {
    user: null,
    superAdmin: false,
    menu: {},
    token: "",
}

const getters = {
    user: state => state.user,
    superAdmin: state => state.superAdmin,
    menu: state => state.menu,
    token: state => state.token,
}

const mutations = {
    setUser(state, user) {
        state.user = user;
    },
    setSuperAdmin(state, superAdmin) {
        state.superAdmin = superAdmin;
    },
    setMenu(state, menu) {
        // console.log("set menu menu = " + JSON.stringify(menu));
        state.menu = menu;
    },
    clearUser(state) {
        console.log("clearUser clearData");
        state.user = null;
        localStorage.removeItem("ystadmin_user");
        localStorage.removeItem("ystadmin_token");
    },
    setToken(state, token) {
        state.token = token;
    }
    
}

const actions = {
    initUser({ commit }) {
        let userStr = localStorage.getItem("ystadmin_user");
        // console.log("initUser userStr = " + userStr);
        if (userStr) {
            let user = JSON.parse(userStr);
            commit("setUser", user);
        }

        let tokenStr = localStorage.getItem("ystadmin_token");
        // console.log("initUser tokenStr = " + tokenStr);
        if (tokenStr) {
            commit("setToken", tokenStr);
        }
    },
    clearUser({ commit }) {
        console.log("clearUser clearData");
        localStorage.removeItem("ystadmin_user");
        commit("setUser", null);
        commit("setSuperAdmin", false);
        commit("clearUser");
    },
    userLogin({ commit }, user) {
        commit("setUser", user);
    },
    userLoginCache({ commit }, user) {
        let userStr = JSON.stringify(user);
        localStorage.setItem("ystadmin_user", userStr);
        commit("setUser", user);
    },
    setSuperAdmin({ commit }, superAdmin) {
        commit("setSuperAdmin", superAdmin);
    },
    setMenu({ commit }, menu) {
        commit("setMenu", menu);
    },
    setToken({ commit }, token) {
        localStorage.setItem("ystadmin_token", token);
        commit("setToken", token);
    },

    
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
  



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js